import AssetManager from '@/asset-manager';

export class MediaUtil {
    static getMediaUrl(media) {
        if (!media) {
            return ''
        }

        let mediaFilename = this.getMediaFilename(media)

        if (mediaFilename.match(/^emoji-/)) {
            mediaFilename = 'emojis/' + mediaFilename;
        }

        let asset = AssetManager.getAsset(mediaFilename);

        if (!asset) {
            throw new Error(`Could not find asset by media filename "${mediaFilename}"!`);
        }

        return asset;
    }

    static getMediaFilename(media) {
        if (!media.match(/\.(png|jpg|gif)$/)) {
            media += '.png';
        }

        return media;
    }

    static getMediaAlt(media) {
        let alt = media;

        // Remove everything before the first slash (eg. /my/picture/here.png = here.png)
        alt = alt.replace(/.*\//g, '');

        // Remove extension
        alt = alt.replace(/\.(png|jpg|gif)$/g, '');

        // Remove "emoji" prefix
        alt = alt.replace(/^emoji\-/g, '');

        // Remove size
        alt = alt.replace(/\-\d+x\d+$/g, '');

        let altSplit = alt.split(/\s*[\-]+\s*/g);

        for (let i = 0, len = altSplit.length; i < len; i++) {
            altSplit[i] = altSplit[i].substr(0, 1).toUpperCase() + altSplit[i].substr(1);
        }

        return altSplit.join(' ');
    }
}